import { useBaseApi } from "api/base-api";
import { IDeliveryAreaApi } from "./interfaces";
import { IDeliveryAreaGeoJSONDto } from "./interfaces-result";
import { IResultBaseGeneric } from "api/interfaces";

export const useDeliveryAreaApi: () => IDeliveryAreaApi =
  (): IDeliveryAreaApi => {
    const { baseGetRequest } = useBaseApi();

    const getGeoJSONList: () => Promise<
      IResultBaseGeneric<IDeliveryAreaGeoJSONDto[]>
    > = async (): Promise<IResultBaseGeneric<IDeliveryAreaGeoJSONDto[]>> => {
      let url: string = "/DeliveryArea/GetGeoJSONList";
      return await baseGetRequest<
        IResultBaseGeneric<IDeliveryAreaGeoJSONDto[]>
      >(url);
    };

    return { getGeoJSONList };
  };
